/**
 * Right-panel tab id for the skill level editor. Shared by the manifest (tab
 * declaration) and the center list (which opens/focuses that tab on interaction)
 * so the literal stays in a single place.
 */
export const SKILL_LEVEL_EDIT_TAB = 'skill-level-edit';
